import React from 'react'

const SLLabelValueCompare = () => (
  <div>
    <svg width="140px" height="68px" viewBox="0 0 140 68" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="1.0-Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Broker-Portal---Dashboard---Loading" transform="translate(-277.000000, -456.000000)" fill="#F1F1F4">
          <g id="label+value2" transform="translate(277.000000, 456.000000)">
            <rect id="Label" x="0" y="0" width="98" height="10"/>
            <rect id="Value" x="0" y="22" width="140" height="46"/>
          </g>
        </g>
      </g>
    </svg>
  </div>
)

export default SLLabelValueCompare
